import _filter from 'lodash/filter';
import { REFUND_STATUS, REQUEST_STATUS } from '../constants';

export const makeActionHandler = (action: any, params: any) => {
	const { approveAndRefundRequestInBulk, selection } = params;
	const refundReqIdList = selection.map((r: any) => r.id);
	const refundedRequests = _filter(
		selection,
		(r: any) =>
			r.data.approvalStatus === REQUEST_STATUS.APPROVED &&
			(r.data.refundStatus === REFUND_STATUS.PENDING || r.data.refundStatus === REFUND_STATUS.SUCCESS)
	);

	switch (action.id) {
		case 'approve':
			return () => {
				const isRefunded = refundedRequests.length > 0;
				approveAndRefundRequestInBulk({ refundReqIdList, isRejected: false }, isRefunded);
			};
		case 'reject':
			return () => {
				const isRefunded = refundedRequests.length > 0;
				approveAndRefundRequestInBulk({ refundReqIdList, isRejected: true }, isRefunded);
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
